import { Grid } from "@mui/material";
import type { HunterDetailDto } from "Infrastructure/Api/Api";
import { UserStatusCell } from "Components/Users/UserListTable/UserStatusCell";
import { Resources, useResource } from "Translations/Resources";
import { GridItem } from "Components/Shared/GridItem";
import { formatDate } from "Utils/DateUtils";
import { PaperTitle } from "Components/Shared/PaperTitle";

const RESOURCES = Resources.Hunter.HuntersOverview.Detail;

type Props = {
  hunter: HunterDetailDto;
};

export const UserInfoSection = ({
  hunter: { login, status, dateCreated, affiliatedToName, affiliatedToEmail },
}: Props) => {
  const { t } = useResource();

  const affiliatedToValue = affiliatedToName
    ? `${affiliatedToName} (${affiliatedToEmail})`
    : affiliatedToEmail || "-";

  return (
    <>
      <PaperTitle>{t(RESOURCES.UserInfo)}</PaperTitle>
      <Grid container spacing={2}>
        <GridItem label={t(RESOURCES.Login)} value={login} />
        <GridItem
          label={t(RESOURCES.Status)}
          value={<UserStatusCell status={status} />}
        />
        <GridItem
          label={t(RESOURCES.DateCreated)}
          value={formatDate(dateCreated)}
        />
        <GridItem label={t(RESOURCES.AffiliatedTo)} value={affiliatedToValue} />
      </Grid>
    </>
  );
};
